__turbopack_context__.v({
  "button": "button-module-scss-module__wo1Z-G__button",
  "contained": "button-module-scss-module__wo1Z-G__contained",
  "disabled": "button-module-scss-module__wo1Z-G__disabled",
  "equal-dimension": "button-module-scss-module__wo1Z-G__equal-dimension",
  "error": "button-module-scss-module__wo1Z-G__error",
  "full-width": "button-module-scss-module__wo1Z-G__full-width",
  "icon": "button-module-scss-module__wo1Z-G__icon",
  "icon-large": "button-module-scss-module__wo1Z-G__icon-large",
  "icon-medium": "button-module-scss-module__wo1Z-G__icon-medium",
  "icon-small": "button-module-scss-module__wo1Z-G__icon-small",
  "large": "button-module-scss-module__wo1Z-G__large",
  "medium": "button-module-scss-module__wo1Z-G__medium",
  "neutral": "button-module-scss-module__wo1Z-G__neutral",
  "outline": "button-module-scss-module__wo1Z-G__outline",
  "primary": "button-module-scss-module__wo1Z-G__primary",
  "round": "button-module-scss-module__wo1Z-G__round",
  "round-outline": "button-module-scss-module__wo1Z-G__round-outline",
  "secondary": "button-module-scss-module__wo1Z-G__secondary",
  "small": "button-module-scss-module__wo1Z-G__small",
  "text": "button-module-scss-module__wo1Z-G__text",
  "transparent": "button-module-scss-module__wo1Z-G__transparent",
  "x-large": "button-module-scss-module__wo1Z-G__x-large",
  "x-small": "button-module-scss-module__wo1Z-G__x-small",
});
